(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/app"],{

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toggles */ "./src/js/toggles.js");
/* harmony import */ var _custom_add_to_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./custom-add-to-cart */ "./src/js/custom-add-to-cart.js");
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* harmony import */ var _price_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./price-slider */ "./src/js/price-slider.js");
/* harmony import */ var _price_slider__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_price_slider__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _collection_description__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./collection-description */ "./src/js/collection-description.js");
/* harmony import */ var _collection_description__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_collection_description__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! bootstrap/js/dist/tab */ "./node_modules/bootstrap/js/dist/tab.js");
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! bootstrap/js/dist/modal */ "./node_modules/bootstrap/js/dist/modal.js");
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @fancyapps/fancybox */ "./node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js");
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! js-cookie */ "./node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _find_my_pot__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./find-my-pot */ "./src/js/find-my-pot.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");












window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var mq = {
  xxs: 0,
  xs: 380,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 1800
};
var responsiveChanges = function responsiveChanges() {
  changeFooter();
};
responsiveChanges();
function changeFooter() {
  var windowWidth = $(window).width();
  if (windowWidth < mq.md) {
    $(".footer-top-menus__menu ul").hide().addClass("is-hidden");
  } else {
    $(".footer-top-menus__menu ul").show().addClass("is-show");
  }
}
function changeFilter() {
  var windowWidth = $(window).width();
  if (windowWidth < mq.lg) {
    $(".js-drawer-filter").prepend($(".js-collection-filters"));
  } else {
    (0,_functions__WEBPACK_IMPORTED_MODULE_9__.closeFilterPanel)();
    $(".js-collection-filters-aside").append($(".js-collection-filters"));
  }
}
changeFilter();

// Debounce function to limit how often a function is executed
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
function replaceMenu() {
  if ($(window).width() < mq.xs) {
    $(".js-panel-actions").append($(".js-wish-list")).append($(".js-lang-switch"));
    $(".js-header-end").prepend($(".js-header-search"));
    $(".js-panel").prepend($(".js-header-right"));
    $(".js-panel").prepend($(".js-header-nav"));
  } else if ($(window).width() < mq.lg && $(window).width() > mq.xs) {
    $(".js-header-end").prepend($(".js-header-search"));
    $(".js-panel").prepend($(".js-header-right"));
    $(".js-panel").prepend($(".js-header-nav"));
    $(".js-header-main-actions").append($(".js-wish-list")).append($(".js-lang-switch"));
  } else if ($(window).width() < mq.xl && $(window).width() >= mq.lg) {
    $(".js-header-main-right").prepend($(".js-header-search"));
    $(".js-header-main-actions").append($(".js-wish-list")).append($(".js-lang-switch"));
    $(".js-panel").prepend($(".js-header-nav"));
    $(".js-panel").prepend($(".js-header-right"));
  } else {
    $(".js-header-main").append($(".js-header-search"));
    $(".js-header-end .container").prepend($(".js-header-right"));
    $(".js-header-end .container").prepend($(".js-header-nav"));
    $(".js-header-main-actions").append($(".js-wish-list")).append($(".js-lang-switch"));
    $("html").removeClass("show-nav");
    $(".js-header-toggle").removeClass("is-active");
  }
}
var replaceHome = function replaceHome() {
  (0,_sliders__WEBPACK_IMPORTED_MODULE_2__.destroyHomeHeroAsideMobileSlider)();
  if ($(window).width() < mq.md) {
    $(".js-home-hero-top").append($(".js-home-hero-usp"));
    $(".js-home-hero-middle").append($(".js-home-hero-category"));
    $(".js-home-hero-end").append($(".js-home-hero-main"));
    if ($(".js-home-hero-aside-mobile .js-home-hero-aside-element").length === 0) {
      $(".js-home-hero-aside-mobile").append($(".js-home-hero-aside-element"));
    }
    if ($(".js-home-hero-aside-mobile .js-category-aside-block").length === 0) {
      $(".js-home-hero-aside-mobile").append($(".js-category-aside-block"));
    }
  } else {
    $(".js-home-hero-top").append($(".js-home-hero-main"));
    $(".js-home-hero-middle").append($(".js-home-hero-usp"));
    $(".js-home-hero-end").append($(".js-home-hero-category"));
    if ($(".js-home-hero-aside-desktop .js-home-hero-aside-element").length === 0) {
      $(".js-home-hero-aside-desktop").append($(".js-home-hero-aside-element"));
    }
    if ($(".js-category-aside .js-category-aside-block").length === 0) {
      $(".js-category-aside").append($(".js-category-aside-block"));
    }
  }
  setTimeout(function () {
    (0,_sliders__WEBPACK_IMPORTED_MODULE_2__.initHomeHeroAsideMobileSlider)();
  }, 250);
};
var replaceHomeList = function replaceHomeList() {
  if ($(window).width() < mq.lg) {
    $(".js-plants-tab-first").append($(".js-plants-content-first"));
    $(".js-plants-tab-second").append($(".js-plants-content-second"));
  } else {
    $(".js-plants-row").prepend($(".js-plants-content-second"));
    $(".js-plants-row").prepend($(".js-plants-content-first"));
  }
};
function checkSiteNotice() {
  // Check the notice if it should be shown
  if (!js_cookie__WEBPACK_IMPORTED_MODULE_8__["default"].get("notice-hidden") || js_cookie__WEBPACK_IMPORTED_MODULE_8__["default"].get("notice-hidden") !== "true") {
    $(".js-site-notice").removeClass("d-none");
    $(".js-home-hero").removeClass("no-sitenotice");
  }
}

// On click js-close-notice use js-cookie to set "notice-hidden" cookie to true and hide the notice
$(document).on("click", ".js-close-notice", function () {
  // Set cookie and hide notice
  js_cookie__WEBPACK_IMPORTED_MODULE_8__["default"].set("notice-hidden", "true", {
    expires: 1
  });
  $(".js-site-notice").addClass("d-none");
  $(".js-home-hero").addClass("no-sitenotice");
});
$(document).on("click", ".js-quickview-toggle", function (event) {
  (0,_find_my_pot__WEBPACK_IMPORTED_MODULE_10__.showQuickView)(event);
});
$(document).on("click", ".js-potting-checkbox", function (event) {
  $(".js-potting-option").toggleClass("show-border");
});
var screenWidth = $(window).width();
$(window).on("resize", function () {
  if (screenWidth === $(window).width()) {
    return;
  }
  screenWidth = $(window).width();
  responsiveChanges();
  replaceMenu();
  changeFilter();
  replaceHome();
  replaceHomeList();
});
checkSiteNotice();
replaceHomeList();
replaceHome();
replaceMenu();

// checkRedirect();

/***/ }),

/***/ "./src/js/collection-description.js":
/*!******************************************!*\
  !*** ./src/js/collection-description.js ***!
  \******************************************/
/***/ (() => {

(function () {
  function initCollectionDescription() {
    var container = document.getElementById('collection-description-sections');
    if (!container) return;

    // Get translations from data attributes
    var readMoreText = container.getAttribute('data-read-more') || 'Lees meer';
    var readLessText = container.getAttribute('data-read-less') || 'Lees minder';

    // Check if already processed (has collection-section-block children)
    if (container.querySelector('.collection-section-block')) {
      return;
    }

    // Get raw HTML - preserve the original content
    var rawHtml = container.innerHTML.trim();
    if (!rawHtml) {
      console.warn('Collection description: No content found');
      return;
    }

    // Store original HTML in case we need to fall back
    var originalHtml = rawHtml;

    // Clear container
    container.innerHTML = '';

    // Create temporary div to parse HTML
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawHtml;

    // Split content by H2 headings
    var sections = [];
    var currentHeading = null;
    var currentContent = [];
    Array.from(tempDiv.childNodes).forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
        // Save previous section if exists
        if (currentHeading || currentContent.length > 0) {
          sections.push({
            heading: currentHeading,
            content: currentContent
          });
        }
        // Start new section
        currentHeading = node.cloneNode(true);
        currentContent = [];
      } else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        // Add to current section content
        currentContent.push(node.cloneNode(true));
      }
    });

    // Add last section
    if (currentHeading || currentContent.length > 0) {
      sections.push({
        heading: currentHeading,
        content: currentContent
      });
    }

    // If no sections were created, restore original HTML and return
    if (sections.length === 0) {
      console.warn('Collection description: No sections found, restoring original content');
      container.innerHTML = originalHtml;
      return;
    }

    // Create blocks for each section
    sections.forEach(function (section, index) {
      // Skip empty sections - check if there's any meaningful content
      if (!section.heading && section.content.length === 0) {
        return;
      }

      // Check if all content is empty (only whitespace text nodes)
      if (!section.heading && section.content.length > 0) {
        var hasContent = section.content.some(function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent.trim().length > 0;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            return node.textContent.trim().length > 0 || node.children.length > 0;
          }
          return true;
        });
        if (!hasContent) {
          return;
        }
      }
      var sectionBlock = document.createElement('div');
      sectionBlock.classList.add('col-lg-6', 'col-12');
      var innerBlock = document.createElement('div');
      innerBlock.classList.add('collection-section-block');

      // Add heading if exists
      if (section.heading) {
        innerBlock.appendChild(section.heading.cloneNode(true));
      }

      // Create content wrapper
      var contentWrapper = document.createElement('div');
      contentWrapper.classList.add('collection-section-content');

      // Build full content HTML by cloning nodes
      var fullContentDiv = document.createElement('div');
      section.content.forEach(function (node) {
        fullContentDiv.appendChild(node.cloneNode(true));
      });

      // Get plain text for truncation
      var plainText = fullContentDiv.textContent || fullContentDiv.innerText || '';
      var words = plainText.trim().split(/\s+/).filter(function (word) {
        return word.length > 0;
      });
      var shortWordCount = 20;
      if (words.length > shortWordCount) {
        // Create preview paragraph
        var shortText = words.slice(0, shortWordCount).join(' ') + '...';
        var previewP = document.createElement('p');
        previewP.classList.add('collection-section-preview');
        previewP.style.marginBottom = '0';
        var previewText = document.createTextNode(shortText + ' ');
        previewP.appendChild(previewText);

        // Create "Read more" button (inline with preview)
        var readMoreBtn = document.createElement('button');
        readMoreBtn.type = 'button';
        readMoreBtn.classList.add('read-more-btn');
        readMoreBtn.innerHTML = '<span class="read-more-icon">+</span> <span class="read-more-text">' + readMoreText + '</span>';
        readMoreBtn.setAttribute('data-expanded', '0');

        // Create full content (hidden initially)
        var fullDiv = document.createElement('div');
        fullDiv.classList.add('collection-section-full');
        fullDiv.style.display = 'none';

        // Clone all content nodes into fullDiv
        section.content.forEach(function (node) {
          fullDiv.appendChild(node.cloneNode(true));
        });

        // Create "Read less" button for full content
        var readLessBtn = document.createElement('button');
        readLessBtn.type = 'button';
        readLessBtn.classList.add('read-more-btn');
        readLessBtn.innerHTML = '<span class="read-more-icon">−</span> <span class="read-more-text">' + readLessText + '</span>';
        readLessBtn.style.marginTop = '8px';

        // Add button to full content
        fullDiv.appendChild(readLessBtn);

        // "Read more" button click handler
        readMoreBtn.addEventListener('click', function (e) {
          e.preventDefault();
          previewP.style.display = 'none';
          fullDiv.style.display = 'block';
        });

        // "Read less" button click handler
        readLessBtn.addEventListener('click', function (e) {
          e.preventDefault();
          previewP.style.display = 'block';
          fullDiv.style.display = 'none';
        });

        // Append elements
        previewP.appendChild(readMoreBtn);
        contentWrapper.appendChild(previewP);
        contentWrapper.appendChild(fullDiv);
      } else {
        // Content is short, show all by appending nodes directly
        section.content.forEach(function (node) {
          contentWrapper.appendChild(node.cloneNode(true));
        });
      }
      innerBlock.appendChild(contentWrapper);
      sectionBlock.appendChild(innerBlock);
      container.appendChild(sectionBlock);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDescription);
  } else {
    // DOM is already ready
    initCollectionDescription();
  }

  // Also listen for Shopify section:load event (for theme editor)
  document.addEventListener('shopify:section:load', initCollectionDescription);
})();

/***/ }),

/***/ "./src/js/custom-add-to-cart.js":
/*!**************************************!*\
  !*** ./src/js/custom-add-to-cart.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   updateCart: () => (/* binding */ updateCart)
/* harmony export */ });
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }


var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
addToCartForms.forEach(function (form) {
  form.addEventListener('submit', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var res, cart;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            _context.next = 3;
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: "POST",
              body: new FormData(form)
            });
          case 3:
            _context.next = 5;
            return fetch(window.Shopify.routes.root + 'cart.js');
          case 5:
            res = _context.sent;
            _context.next = 8;
            return res.json();
          case 8:
            cart = _context.sent;
            document.querySelector('.js-cart-count').classList.add('header-main__cart--hasitems');
            document.querySelectorAll('.js-cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            // Update Mini Cart
            _context.next = 13;
            return updateCart(cart);
          case 13:
            (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
            (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
});

/**
 * Handle related products add to cart
 */
function initRelatedAddToCart() {
  var addToCartItems = document.querySelectorAll('form.js-related-add-to-cart');
  addToCartItems.forEach(function (form) {
    form.addEventListener('submit', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var res, cart;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();
              _context2.next = 3;
              return fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: "POST",
                body: new FormData(form)
              });
            case 3:
              _context2.next = 5;
              return fetch(window.Shopify.routes.root + 'cart.js');
            case 5:
              res = _context2.sent;
              _context2.next = 8;
              return res.json();
            case 8:
              cart = _context2.sent;
              document.querySelector('.js-cart-count').classList.add('header-main__cart--hasitems');
              document.querySelectorAll('.js-cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              // Update Mini Cart
              _context2.next = 13;
              return updateCart(cart);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  });
}
function updateCart(_x3) {
  return _updateCart.apply(this, arguments);
}
function _updateCart() {
  _updateCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(cart) {
    var pathParts, minicartSectionUrl, res, text, html, newBox, jsCart, cartSectionUrl, _res, _text, _html, _newBox, $upsell;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return new Promise(function (resolve) {
            window.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                action: 'add',
                cart: cart,
                done: resolve // listeners roepen dit aan als ze klaar zijn
              }
            }));
          });
        case 2:
          pathParts = window.location.pathname.split('/').filter(Boolean); // Verwijdert lege strings
          minicartSectionUrl = pathParts.length > 0 ? "/".concat(pathParts[0], "/?section_id=base-minicart") : "/?section_id=base-minicart";
          _context7.next = 6;
          return fetch(minicartSectionUrl);
        case 6:
          res = _context7.sent;
          _context7.next = 9;
          return res.text();
        case 9:
          text = _context7.sent;
          html = document.createElement('div');
          html.innerHTML = text;
          newBox = html.querySelector(".drawer-cart");
          document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;

          // Check if there's a .js-cart on the page
          jsCart = document.querySelector('.js-cart');
          if (!jsCart) {
            _context7.next = 27;
            break;
          }
          cartSectionUrl = pathParts.length > 0 ? "/".concat(pathParts[0], "/?section_id=page-cart") : "/?section_id=page-cart";
          _context7.next = 19;
          return fetch(cartSectionUrl);
        case 19:
          _res = _context7.sent;
          _context7.next = 22;
          return _res.text();
        case 22:
          _text = _context7.sent;
          _html = document.createElement('div');
          _html.innerHTML = _text;
          _newBox = _html.querySelector(".js-cart");
          document.querySelector('.js-cart').innerHTML = _newBox.innerHTML;
        case 27:
          // Voeg de event listeners opnieuw toe aan de bijgewerkte winkelwagen items
          addEventListenersToCart();
          initRelatedAddToCart();

          // Ensure minicart upsell row stays horizontal by (re)initializing the slider when available
          try {
            $upsell = __webpack_provided_window_dot_jQuery && __webpack_provided_window_dot_jQuery('.js-drawer-crosssells');
            if ($upsell && $upsell.length) {
              if (!$upsell.hasClass('slick-initialized')) {
                $upsell.slick({
                  slidesToShow: 1.5,
                  slidesToScroll: 1,
                  dots: false,
                  arrows: false,
                  rows: 0,
                  infinite: false
                });
              }
            }
          } catch (e) {
            // no-op; CSS fallback keeps horizontal layout
          }
          (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
        case 31:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _updateCart.apply(this, arguments);
}
function addQuantityUpdateListeners() {
  document.querySelectorAll('.js-cart-item-quantity button').forEach(function (button) {
    button.addEventListener('click', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var rootItem, key, configurationId, updateItems, currentQuantity, isUp, newQuantity, updates, response, data, res, cart;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            rootItem = button.closest('[data-line-item-key]');
            key = rootItem.getAttribute('data-line-item-key'); // Haal configurationId op
            configurationId = rootItem.hasAttribute('data-configuration-id') ? rootItem.getAttribute('data-configuration-id') : null; // Disable buttons voor alle items met hetzelfde configurationId
            updateItems = configurationId ? document.querySelectorAll("[data-configuration-id=\"".concat(configurationId, "\"]")) : [rootItem];
            updateItems.forEach(function (item) {
              item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                return btn.disabled = true;
              });
              item.classList.add('is-updating');
            });

            // Huidige hoeveelheid ophalen van het hoofdproduct
            currentQuantity = parseInt(rootItem.querySelector('.js-cart-item-quantity input').value, 10);
            isUp = button.classList.contains('is-plus');
            newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1; // Stel updates object in voor alle items met hetzelfde configurationId
            updates = {};
            updateItems.forEach(function (item) {
              var itemKey = item.getAttribute('data-line-item-key');
              if (itemKey) {
                updates[itemKey] = newQuantity;
              }
            });

            // AJAX update voor de geselecteerde items
            _context3.next = 12;
            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates: updates
              })
            });
          case 12:
            response = _context3.sent;
            _context3.next = 15;
            return response.json();
          case 15:
            data = _context3.sent;
            // update winkelwagen count
            document.querySelectorAll('.js-cart-count').forEach(function (el) {
              return el.textContent = data.item_count;
            });

            // Verwijder is-updating class en enable de buttons
            updateItems.forEach(function (item) {
              item.classList.remove('is-updating');
              item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                return btn.disabled = false;
              });
            });

            // Get New Cart object
            _context3.next = 20;
            return fetch(window.Shopify.routes.root + 'cart.js');
          case 20:
            res = _context3.sent;
            _context3.next = 23;
            return res.json();
          case 23:
            cart = _context3.sent;
            _context3.next = 26;
            return updateCart(cart);
          case 26:
            document.dispatchEvent(new CustomEvent('lineitem:updated', {
              detail: {
                cart: cart
              }
            }));
            (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
          case 28:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
  });

  // Handle direct input changes
  document.querySelectorAll('.js-cart-item-quantity input').forEach(function (input) {
    var debounceTimer;
    input.addEventListener('input', function () {
      // Allow only numbers
      var value = this.value;
      if (value !== '' && !/^\d+$/.test(value)) {
        this.value = value.replace(/\D/g, '');
      }
    });
    input.addEventListener('change', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _this = this;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
              var rootItem, key, newQuantity, configurationId, updateItems, updates, response, data, res, cart;
              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    rootItem = _this.closest('[data-line-item-key]');
                    key = rootItem.getAttribute('data-line-item-key');
                    newQuantity = parseInt(_this.value, 10); // Validate quantity
                    if (isNaN(newQuantity) || newQuantity < 0) {
                      newQuantity = 0;
                    }

                    // Haal configurationId op
                    configurationId = rootItem.hasAttribute('data-configuration-id') ? rootItem.getAttribute('data-configuration-id') : null; // Disable buttons
                    updateItems = configurationId ? document.querySelectorAll("[data-configuration-id=\"".concat(configurationId, "\"]")) : [rootItem];
                    updateItems.forEach(function (item) {
                      item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                        return btn.disabled = true;
                      });
                      item.classList.add('is-updating');
                    });

                    // Stel updates object in
                    updates = {};
                    updateItems.forEach(function (item) {
                      var itemKey = item.getAttribute('data-line-item-key');
                      if (itemKey) {
                        updates[itemKey] = newQuantity;
                      }
                    });

                    // AJAX update
                    _context4.next = 11;
                    return fetch(window.Shopify.routes.root + 'cart/update.js', {
                      method: "POST",
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify({
                        updates: updates
                      })
                    });
                  case 11:
                    response = _context4.sent;
                    _context4.next = 14;
                    return response.json();
                  case 14:
                    data = _context4.sent;
                    // update winkelwagen count
                    document.querySelectorAll('.js-cart-count').forEach(function (el) {
                      return el.textContent = data.item_count;
                    });

                    // Re-enable buttons
                    updateItems.forEach(function (item) {
                      item.classList.remove('is-updating');
                      item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                        return btn.disabled = false;
                      });
                    });

                    // Get New Cart object
                    _context4.next = 19;
                    return fetch(window.Shopify.routes.root + 'cart.js');
                  case 19:
                    res = _context4.sent;
                    _context4.next = 22;
                    return res.json();
                  case 22:
                    cart = _context4.sent;
                    _context4.next = 25;
                    return updateCart(cart);
                  case 25:
                    document.dispatchEvent(new CustomEvent('lineitem:updated', {
                      detail: {
                        cart: cart
                      }
                    }));
                    (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
                  case 27:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            })), 500); // Wait 500ms after user stops typing
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
  });
}
function showOppottenRemovedNotification(removedItemType) {
  // Remove any existing notifications first to prevent duplicates
  var existingNotifications = document.querySelectorAll('.cart-notification');
  existingNotifications.forEach(function (notification) {
    return notification.remove();
  });

  // Get translation key based on removed item type
  var key = removedItemType === 'plant' ? 'oppotten_removed_plant' : 'oppotten_removed_pot';

  // Get translation from window.cartTranslations (set by Liquid from JSON locale files)
  var messageText = '';
  if (window.cartTranslations && window.cartTranslations[key]) {
    messageText = window.cartTranslations[key];

    // Check if translation is missing or contains "Translation missing"
    if (messageText && messageText.includes('Translation missing')) {
      messageText = '';
    }
  }

  // Fallback if translation not found (should not happen if JSON files are correct)
  if (!messageText) {
    // Use Dutch as final fallback
    messageText = removedItemType === 'plant' ? 'Oppotten verwijderd omdat plant verwijderd is' : 'Oppotten verwijderd omdat pot verwijderd is';
  }
  // Create notification element
  var notification = document.createElement('div');
  notification.className = 'cart-notification bg-warning text-white p-2 rounded-2 mb-2';
  notification.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 10000; max-width: 400px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); animation: slideIn 0.3s ease-out;';
  notification.innerHTML = "\n\t\t<div class=\"d-flex align-items-center gap-2\">\n\t\t\t<i class=\"fa-sharp fa-regular fa-circle-info\" style=\"font-size: 18px;\"></i>\n\t\t\t<span style=\"font-size: 14px; font-weight: 500;\">".concat(messageText, "</span>\n\t\t\t<button class=\"ms-auto bg-transparent border-0 text-white\" style=\"cursor: pointer; font-size: 18px; padding: 0; line-height: 1;\" onclick=\"this.parentElement.parentElement.remove()\">\n\t\t\t\t<i class=\"fa-sharp fa-regular fa-xmark\"></i>\n\t\t\t</button>\n\t\t</div>\n\t");

  // Add animation styles if not already present
  if (!document.getElementById('cart-notification-styles')) {
    var style = document.createElement('style');
    style.id = 'cart-notification-styles';
    style.textContent = "\n\t\t\t@keyframes slideIn {\n\t\t\t\tfrom {\n\t\t\t\t\ttransform: translateX(100%);\n\t\t\t\t\topacity: 0;\n\t\t\t\t}\n\t\t\t\tto {\n\t\t\t\t\ttransform: translateX(0);\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t\t@keyframes slideOut {\n\t\t\t\tfrom {\n\t\t\t\t\ttransform: translateX(0);\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\tto {\n\t\t\t\t\ttransform: translateX(100%);\n\t\t\t\t\topacity: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t";
    document.head.appendChild(style);
  }

  // Add to body
  document.body.appendChild(notification);

  // Auto-remove after 5 seconds
  setTimeout(function () {
    notification.style.animation = 'slideOut 0.3s ease-out';
    setTimeout(function () {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 300);
  }, 5000);
}
function addDeleteListeners() {
  // Remove old event listeners by using event delegation or cloning buttons
  document.querySelectorAll('.js-cart-item-delete__confirm').forEach(function (button) {
    // Clone button to remove all existing event listeners
    var newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    // Add event listener to the new button
    newButton.addEventListener('click', /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
        var rootItem, key, parentContainer, configurationId, itemType, updates, oppottenAutoRemoved, removedItemType, pottingItem, pottingKey, _pottingItem, _pottingKey, deleteOverlay, res, cart;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              e.stopPropagation(); // Prevent event bubbling
              // Find the closest element with data-line-item-key (could be sub-item or main item)
              rootItem = newButton.closest('[data-line-item-key]');
              key = rootItem.getAttribute('data-line-item-key'); // If button has data-line-item-key attribute (for sub-items), use that
              if (newButton.hasAttribute('data-line-item-key')) {
                key = newButton.getAttribute('data-line-item-key');
                rootItem = document.querySelector("[data-line-item-key=\"".concat(key, "\"]"));
              }

              // Find parent cart-item/cart-lineitem container to get configuration_id
              parentContainer = rootItem.closest('.cart-item, .cart-lineitem');
              configurationId = parentContainer && parentContainer.hasAttribute('data-configuration-id') ? parentContainer.getAttribute('data-configuration-id') : null; // Get item type from the rootItem
              itemType = rootItem.getAttribute('data-item-type') || 'plant'; // Zet de updates object op basis van het configurationId en item type
              updates = {};
              oppottenAutoRemoved = false;
              removedItemType = ''; // Voeg het item zelf toe aan updates
              updates[key] = 0;

              // Als het item een configurationId heeft en het is een plant, verwijder ook oppotten (maar niet de pot)
              if (configurationId && itemType === 'plant') {
                // Zoek naar oppotten item met hetzelfde configurationId binnen de parent container
                if (parentContainer) {
                  pottingItem = parentContainer.querySelector('[data-item-type="potting"]');
                  if (pottingItem) {
                    pottingKey = pottingItem.getAttribute('data-line-item-key');
                    if (pottingKey && pottingKey !== key) {
                      updates[pottingKey] = 0;
                      oppottenAutoRemoved = true;
                      removedItemType = 'plant';
                      // Voeg de is-updating class toe aan het oppotten item
                      pottingItem.classList.add('is-updating');
                    }
                  }
                }
              }

              // Als het item een pot is, verwijder ook oppotten (maar niet de plant)
              if (configurationId && itemType === 'pot') {
                // Zoek naar oppotten item met hetzelfde configurationId binnen de parent container
                if (parentContainer) {
                  _pottingItem = parentContainer.querySelector('[data-item-type="potting"]');
                  if (_pottingItem) {
                    _pottingKey = _pottingItem.getAttribute('data-line-item-key');
                    if (_pottingKey && _pottingKey !== key) {
                      updates[_pottingKey] = 0;
                      oppottenAutoRemoved = true;
                      removedItemType = 'pot';
                      // Voeg de is-updating class toe aan het oppotten item
                      _pottingItem.classList.add('is-updating');
                    }
                  }
                }
              }

              // Find the delete overlay (could be a sibling or parent)
              deleteOverlay = newButton.closest('.cart-item-delete') || rootItem.querySelector('.cart-item-delete');
              if (deleteOverlay) {
                deleteOverlay.classList.remove('is-active');
              }

              // Voeg de is-updating class toe aan het item
              rootItem.classList.add('is-updating');

              // AJAX update voor de geselecteerde items
              _context6.next = 18;
              return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  updates: updates
                })
              }).then(function (response) {
                return response.json();
              }).then(function (data) {
                // Update het winkelwagenaantal
                document.querySelectorAll('.js-cart-count').forEach(function (el) {
                  el.textContent = data.item_count;
                });
              });
            case 18:
              // Verwijder de is-updating class van de geselecteerde items
              // Remove is-updating from all items that were in the updates object
              Object.keys(updates).forEach(function (itemKey) {
                var itemElement = document.querySelector("[data-line-item-key=\"".concat(itemKey, "\"]"));
                if (itemElement) {
                  itemElement.classList.remove('is-updating');
                }
              });
              _context6.next = 21;
              return fetch(window.Shopify.routes.root + 'cart.js');
            case 21:
              res = _context6.sent;
              _context6.next = 24;
              return res.json();
            case 24:
              cart = _context6.sent;
              _context6.next = 27;
              return updateCart(cart);
            case 27:
              // Show notification if oppotten was auto-removed
              if (oppottenAutoRemoved) {
                showOppottenRemovedNotification(removedItemType);
              }
              (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
            case 29:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());
  });
}
function addEventListenersToCart() {
  addQuantityUpdateListeners();
  addDeleteListeners();
}

// Initial call to add event listeners
addEventListenersToCart();

// Init related add to cart
initRelatedAddToCart();

// js-cart-item-delete-toggle
$(document).on("click", ".js-cart-item-delete-toggle", function (e) {
  // Find the closest parent container (cart-item__content, cart-item__sub-item, etc.)
  var container = $(this).closest('.cart-item__content, .cart-item__sub-item, .cart-lineitem__content, .cart-lineitem__sub-item');
  // Find the next sibling delete overlay
  var deleteOverlay = container.next('.cart-item-delete');
  if (deleteOverlay.length) {
    deleteOverlay.addClass('is-active');
  } else {
    // Fallback to old method for backwards compatibility
    $(this).parent().parent().parent().next('.cart-item-delete').addClass('is-active');
  }
  addEventListenersToCart();
});
$(document).on("click", ".js-cart-item-delete__close", function (e) {
  // Find the closest delete overlay and remove active class
  $(this).closest('.cart-item-delete').removeClass('is-active');
  addEventListenersToCart();
});


/***/ }),

/***/ "./src/js/find-my-pot.js":
/*!*******************************!*\
  !*** ./src/js/find-my-pot.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PotFinder: () => (/* binding */ PotFinder),
/* harmony export */   showQuickView: () => (/* binding */ showQuickView)
/* harmony export */ });
/* harmony import */ var _custom_add_to_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./custom-add-to-cart */ "./src/js/custom-add-to-cart.js");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"),
  fn = _require.fn,
  type = _require.type;


window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var PotFinder = /*#__PURE__*/function () {
  function PotFinder() {
    _classCallCheck(this, PotFinder);
    // Define the selectors
    this.plantData = ".js-plant-configuration";
    this.potSelector = ".js-select-pot";
    this.pottingOptionsSelector = ".js-potting-option";
    this.pottingOptionsCheckboxes = ".js-potting-checkbox";

    // Hold the selected pot and potting
    this.selectedPot = null;
    this.selectedPotting = null;

    // Define an add-to-cart array
    this.addToCartObject = [];

    // Quantity selectors
    this.quantityInputSelector = ".cart-item-quantity__input";
    this.minusButtonSelector = ".cart-item-quantity__btns.is-min";
    this.plusButtonSelector = ".cart-item-quantity__btns.is-plus";

    // Add to cart btn
    this.addToCartButton = ".js-add-to-cart";

    // Define diameter options
    this.pottingDiameters = [];

    // Initialize the find-my-pot logic
    this.init();
  }

  /**
   * Init function to setup the find-my-pot logic
   */
  return _createClass(PotFinder, [{
    key: "init",
    value: function init() {
      this.getPottingDiameters(); // Get the potting diameters
      this.addEventListeners(); // Add event listeners
    }

    /**
     * Get the potting diameters
     *
     * @returns void
     */
  }, {
    key: "getPottingDiameters",
    value: function getPottingDiameters() {
      var _this = this;
      var pottingOptions = $(this.pottingOptionsSelector); // Gebruik jQuery om elementen te selecteren
      this.pottingDiameters = [];
      pottingOptions.each(function (index, option) {
        _this.pottingDiameters.push($(option).data("diameter")); // Gebruik jQuery om toegang te krijgen tot data attributen
      });
    }

    /**
     * Add event listeners to the necessary elements
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      $(this.potSelector).on("click", this.handlePotChange.bind(this));
      $(this.pottingOptionsCheckboxes).on("change", this.updateTotalConfigurationPrice.bind(this));

      // Quantity selectors
      $(this.minusButtonSelector).on("click", this.updateQuantity.bind(this, -1));
      $(this.plusButtonSelector).on("click", this.updateQuantity.bind(this, 1));
      $(this.quantityInputSelector).on("input", function (fn) {
        var value = $(_this2.quantityInputSelector).val();
        if (value !== '' && !/^\d+$/.test(value)) {
          $(_this2.quantityInputSelector).val(value.replace(/\D/g, ''));
        }
      });
      $(this.quantityInputSelector).on("blur", function () {
        var value = $(_this2.quantityInputSelector).val();
        var quantity = parseInt(value, 10);
        if (value === '' || isNaN(quantity) || quantity < 1) {
          $(_this2.quantityInputSelector).val(1);
        }
        _this2.updateTotalConfigurationPrice();
      });

      // Add to cart button
      $(this.addToCartButton).on("click", this.addToCart.bind(this));
    }

    /**
     * Handle the pot change event, we need to do several things here:
     * 1. Check if the current "radio" pot input is selected, if so deselect it, else select it... Since radio inputs are not deselected by default
     * 2. Get the selected pot diameter and check if that minimum diameter is available in the potting options
     * 3. Handle the potting options
     * 4. Update the total configuration price
     * 5. Create the add to cart object
     *
     * @param {Event} event
     */
  }, {
    key: "handlePotChange",
    value: function handlePotChange(event) {
      event.preventDefault(); // Prevent the default event
      var selectedPot = $(event.currentTarget).parent().find("input"); // Get selected jQuery object

      // Step 1: Handle the checked state of the radio input
      if (selectedPot.is(":checked")) selectedPot.prop("checked", false);else selectedPot.prop("checked", true);

      // Fill the data of the quickview info:
      var quickViewData = $(event.currentTarget).parent().find(".js-quickview-toggle");
      $(".js-quickview__title").html(quickViewData.data("title"));
      $(".js-quickview__image").attr("src", quickViewData.data("image"));

      // Populate measurements and materials
      var potDiameter = quickViewData.data("pot-diameter") || quickViewData.data("pot-opening");
      var potMaterial = quickViewData.data("pot-material");

      // Show diameter or N/A
      var diameterText = potDiameter ? potDiameter + " cm" : "N/A";
      $(".js-quickview__diameter span.fw-semibold").text(diameterText);

      // Show material or N/A
      var materialText = potMaterial && potMaterial !== "" ? potMaterial : "N/A";
      $(".js-quickview__material span.fw-semibold").text(materialText);

      // Show when needed
      if (selectedPot.is(":checked")) $(".js-quick-view-detail").removeClass("d-none");else $(".js-quick-view-detail").addClass("d-none");
      var price = quickViewData.data("price");
      var priceString = price.toString();
      var modifiedPrice = priceString.slice(0, -2) + "<span>" + priceString.slice(-2) + "</span>";
      $(".js-quickview__price").html(modifiedPrice);

      // Save globally
      this.selectedPot = selectedPot.is(":checked") ? selectedPot : null;

      // Step 2: Get the selected pot diameter
      var selectedPotDiameter = this.getOppotDiameter(selectedPot.is(":checked") ? selectedPot.data("diameter") : null);

      // Step 3: Handle the potting options
      this.handlePottingOptions(selectedPotDiameter);

      // Step 4: Update the total configuration price
      this.updateTotalConfigurationPrice();
    }

    /**
     * Get oppot diameter
     *
     * @param {number} diameter
     *
     * @returns {number|null}
     */
  }, {
    key: "getOppotDiameter",
    value: function getOppotDiameter(diameter) {
      // Start off with nothing
      var fittingDiameter = null;

      // Loop over the potting diameters to find the first one that fits
      this.pottingDiameters.forEach(function (pottingDiameter) {
        // As long as it's bigger we need the more expensive potting option
        if (diameter >= pottingDiameter) {
          fittingDiameter = pottingDiameter;
          return;
        }
      });
      return fittingDiameter;
    }

    /**
     * Handle the potting options
     *
     * @param {number|null} diameter
     */
  }, {
    key: "handlePottingOptions",
    value: function handlePottingOptions(oppotDiameter) {
      // If there's no diameter, we need to hide all the options and uncheck all the checkboxes
      if (oppotDiameter === null) {
        $(this.pottingOptionsSelector).removeClass("is-active");
        $(this.pottingOptionsCheckboxes).prop("checked", false);
        this.selectedPotting = null;
        return;
      }

      // Get the potting option that matches the diameter
      var matchingPottingOption = $("".concat(this.pottingOptionsSelector, "[data-diameter=\"").concat(oppotDiameter, "\"]"));

      // Save the potting option globally
      this.selectedPotting = matchingPottingOption;

      // If this option already has the class 'active' don't do anything
      if (matchingPottingOption.hasClass("is-active")) return;

      // if there's a $(this.pottingOptionsCheckboxes) where checked is true, uncheck all and recheck the matching one
      if ($(this.pottingOptionsCheckboxes).is(":checked")) {
        $(this.pottingOptionsCheckboxes).prop("checked", false);
        matchingPottingOption.find(this.pottingOptionsCheckboxes).prop("checked", true);
      }

      // Remove the checked state from all the checkboxes
      $(this.pottingOptionsSelector).removeClass("is-active");
      matchingPottingOption.addClass("is-active");
    }

    /**
     * Update the total configuration price
     */
  }, {
    key: "updateTotalConfigurationPrice",
    value: function updateTotalConfigurationPrice() {
      var _plantData$data, _$$val;
      // Reset the add to cart object
      this.addToCartObject = [];

      // Get the quantity from the product input
      var quantity = parseInt($('input[name="quantity"]').val());

      // Get the plant and it's initial price
      var plantData = $(this.plantData);
      var plantPrice = (_plantData$data = plantData.data("price")) !== null && _plantData$data !== void 0 ? _plantData$data : 0;
      var plantProductId = plantData.data("product-id");
      var plantProductVariantId = (_$$val = $('#variant-id').val()) !== null && _$$val !== void 0 ? _$$val : null;
      if (plantData.length > 0) {
        // Add the pot to the cart
        this.addToCartObject.push({
          id: plantProductId,
          variation: plantProductVariantId,
          quantity: quantity,
          type: 'plant'
        });
      }

      // Get the pot data
      var potData = $(this.selectedPot);
      var potPrice = potData.length > 0 ? potData.data("pot-price") : null;
      var potVariationId = potData.length > 0 ? parseInt(potData.val()) : null;
      var potProductId = potData.length > 0 ? potData.data("product-id") : null;

      // if there's a pot, add it to the cart
      if (potData.length > 0) {
        this.addToCartObject.push({
          id: potProductId,
          variation: potVariationId,
          quantity: quantity,
          type: 'pot'
        });
      }
      if (this.selectedPotting === null) {
        // Fallback: if no match is found, use .singular_potting_option
        this.selectedPotting = $('.singular_potting_option');
      }

      // Get the potting data
      var pottingData = $(this.selectedPotting).find(".js-potting-checkbox:checked");
      var pottingPrice = pottingData.length > 0 ? pottingData.data("potting-price") : null;
      var pottingVariationId = pottingData.length > 0 ? parseInt(pottingData.val()) : null;
      var pottingProductId = pottingData.length > 0 ? pottingData.data("product-id") : null;

      // if there's a potting option, add it to the cart
      if (pottingData.length > 0) {
        this.addToCartObject.push({
          id: pottingProductId,
          variation: pottingVariationId,
          quantity: quantity,
          type: 'potting'
        });
      }

      // Get the total price
      var totalPrice = 0;
      if (plantPrice > 0) totalPrice += plantPrice * quantity;
      if (potPrice > 0) totalPrice += potPrice * quantity;
      if (pottingPrice > 0) totalPrice += pottingPrice * quantity;

      // Fill in the price
      if (potData.length > 0 || pottingData.length > 0) $(".js-configuration-price").removeClass("d-none");else $(".js-configuration-price").addClass("d-none");
      $(".js-total-cents").text(totalPrice.toString().slice(-2));
      $(".js-total-euros").text(totalPrice.toString().slice(0, -2));
    }

    /**
     * Add to cart functionality
     */
  }, {
    key: "addToCart",
    value: (function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var productData, requestBody, res, cart, errorMessage;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // If the add to cart object is empty, run over the updateTotalConfigurationPrice function
              if (this.addToCartObject.length === 0) this.updateTotalConfigurationPrice();
              productData = this.addToCartObject.map(function (product) {
                var _product$variation;
                return {
                  id: (_product$variation = product.variation) !== null && _product$variation !== void 0 ? _product$variation : product.id,
                  quantity: product.quantity,
                  properties: {
                    _sub: "true",
                    _configuration_id: Date.now(),
                    _type: product.type
                  }
                };
              }); // Turn the array upside down
              productData.reverse();

              // Now from the first item remove the properties.sub
              if (productData.length > 0 && productData[productData.length - 1].properties) {
                productData[productData.length - 1].properties._sub = "false";
              }

              // Voeg eigenschappen toe als er meer dan 1 item is
              if (this.addToCartObject.length === 1) {
                productData[0].properties = null;
              }

              // Setup the request body
              requestBody = {
                items: productData
              };
              _context.prev = 6;
              _context.next = 9;
              return $.ajax({
                url: "/cart/add.js",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(requestBody)
              });
            case 9:
              _context.next = 11;
              return fetch(window.Shopify.routes.root + 'cart.js');
            case 11:
              res = _context.sent;
              _context.next = 14;
              return res.json();
            case 14:
              cart = _context.sent;
              _context.next = 17;
              return (0,_custom_add_to_cart__WEBPACK_IMPORTED_MODULE_0__.updateCart)(cart);
            case 17:
              (0,_functions__WEBPACK_IMPORTED_MODULE_1__.openMiniCart)();
              _context.next = 24;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](6);
              // Parse the error response
              errorMessage = JSON.parse(_context.t0.responseText);
              alert(errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 20]]);
      }));
      function addToCart() {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
    /**
     * Update quantity
     *
     * @param {Number} increment
     */
    )
  }, {
    key: "updateQuantity",
    value: function updateQuantity(increment) {
      // Get the current quantity
      var currentQuantity = parseInt($(this.quantityInputSelector).val(), 10);

      // If it's not a number, set it to 0
      if (isNaN(currentQuantity)) currentQuantity = 0;

      // Get the new quantity
      var newQuantity = currentQuantity + increment;

      // Overwrite the value
      if (newQuantity >= 1) $(this.quantityInputSelector).val(newQuantity);

      // Update the total configuration price
      this.updateTotalConfigurationPrice();
    }
  }]);
}();
/**
 * Show the find-my-pot product quickview
 */
var showQuickView = function showQuickView(event) {
  // Get the product and fill the quickview
  var product = $(event.currentTarget);
  $(".js-quickview__title").html(product.data("title"));
  $(".js-quickview__image").attr("src", product.data("image"));
  var price = product.data("price");
  var priceString = price.toString();
  var modifiedPrice = priceString.slice(0, -2) + ",<span>" + priceString.slice(-2) + "</span>";
  $(".js-quickview__price").html(modifiedPrice);

  // Populate measurements and materials
  var potDiameter = product.data("pot-diameter") || product.data("pot-opening");
  var potMaterial = product.data("pot-material");

  // Show diameter or N/A
  var diameterText = potDiameter ? potDiameter + " cm" : "N/A";
  $(".js-quickview__diameter span.fw-semibold").text(diameterText);

  // Show material or N/A
  var materialText = potMaterial && potMaterial !== "" ? potMaterial : "N/A";
  $(".js-quickview__material span.fw-semibold").text(materialText);
};


/***/ }),

/***/ "./src/js/functions.js":
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   closeAccountPanel: () => (/* binding */ closeAccountPanel),
/* harmony export */   closeFilterPanel: () => (/* binding */ closeFilterPanel),
/* harmony export */   closeLangPanel: () => (/* binding */ closeLangPanel),
/* harmony export */   closeMiniCart: () => (/* binding */ closeMiniCart),
/* harmony export */   filterToggle: () => (/* binding */ filterToggle),
/* harmony export */   lockHTML: () => (/* binding */ lockHTML),
/* harmony export */   openAccountPanel: () => (/* binding */ openAccountPanel),
/* harmony export */   openFilterPanel: () => (/* binding */ openFilterPanel),
/* harmony export */   openLangPanel: () => (/* binding */ openLangPanel),
/* harmony export */   openMiniCart: () => (/* binding */ openMiniCart),
/* harmony export */   unlockHTML: () => (/* binding */ unlockHTML)
/* harmony export */ });
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var openMiniCart = function openMiniCart() {
  $(".drawer-cart").toggleClass("is-open");
};
var closeMiniCart = function closeMiniCart() {
  $(".drawer-cart").removeClass("is-open");
};
var openLangPanel = function openLangPanel() {
  $(".drawer-lang").toggleClass("is-open");
};
var closeLangPanel = function closeLangPanel() {
  $(".drawer-lang").removeClass("is-open");
};
var openAccountPanel = function openAccountPanel() {
  $(".drawer-account").toggleClass("is-open");
};
var closeAccountPanel = function closeAccountPanel() {
  $(".drawer-account").removeClass("is-open");
};
var filterToggle = function filterToggle(element) {
  if (element.parent().hasClass('is-hidden')) {
    element.parent().removeClass('is-hidden').find('.collection-filter-content').stop().slideToggle();
  } else {
    element.parent().addClass('is-hidden').find('.collection-filter-content').stop().slideToggle();
  }
};
var openFilterPanel = function openFilterPanel() {
  $(".drawer-filter").toggleClass("is-open");
};
var closeFilterPanel = function closeFilterPanel() {
  $(".drawer-filter").removeClass("is-open");
};
var lockHTML = function lockHTML() {
  if (!$("html").hasClass("is-locked")) {
    $("html").addClass("is-locked");
  }
};
var unlockHTML = function unlockHTML() {
  $("html").removeClass("is-locked");
};


/***/ }),

/***/ "./src/js/price-slider.js":
/*!********************************!*\
  !*** ./src/js/price-slider.js ***!
  \********************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Price Range Slider with Filter Integration
 * Syncs slider handles with input fields and applies filters
 */
var PriceRangeSlider = /*#__PURE__*/function () {
  function PriceRangeSlider(container) {
    _classCallCheck(this, PriceRangeSlider);
    this.container = container;
    this.rangeMin = container.querySelector('.price-range-filter__range-min');
    this.rangeMax = container.querySelector('.price-range-filter__range-max');
    this.inputMin = container.querySelector('.price-range-filter__input-min');
    this.inputMax = container.querySelector('.price-range-filter__input-max');
    this.fill = container.querySelector('.price-range-filter__fill');
    this.valueMinDisplay = container.querySelector('.price-range-filter__value-min-num');
    this.valueMaxDisplay = container.querySelector('.price-range-filter__value-max-num');
    this.max = parseInt(container.getAttribute('data-max')) || 2000;
    this.min = 0;
    this.minGap = 10;

    // Prevent circular updates
    this.updatingFromSlider = false;
    this.updatingFromInput = false;

    // Debounce timers for filter application
    this.filterDebounceTimer = null;
    this.filterDebounceDelay = 400; // milliseconds

    if (!this.rangeMin || !this.rangeMax || !this.inputMin || !this.inputMax) {
      return;
    }
    this.init();
  }
  return _createClass(PriceRangeSlider, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Set initial values
      this.updateFill();
      this.updateDisplayValues();

      // Slider events
      this.rangeMin.addEventListener('input', function () {
        return _this.handleMinSlider();
      });
      this.rangeMax.addEventListener('input', function () {
        return _this.handleMaxSlider();
      });

      // Input events
      this.inputMin.addEventListener('input', function () {
        return _this.handleMinInput();
      });
      this.inputMin.addEventListener('blur', function () {
        return _this.handleMinInputBlur();
      });
      this.inputMax.addEventListener('input', function () {
        return _this.handleMaxInput();
      });
      this.inputMax.addEventListener('blur', function () {
        return _this.handleMaxInputBlur();
      });

      // Update fill position on initial load
      this.updateFill();
    }
  }, {
    key: "getMinValue",
    value: function getMinValue() {
      return parseInt(this.rangeMin.value) || this.min;
    }
  }, {
    key: "getMaxValue",
    value: function getMaxValue() {
      return parseInt(this.rangeMax.value) || this.max;
    }
  }, {
    key: "updateFill",
    value: function updateFill() {
      var minVal = this.getMinValue();
      var maxVal = this.getMaxValue();
      var minPercent = minVal / this.max * 100;
      var maxPercent = maxVal / this.max * 100;
      this.fill.style.left = "".concat(minPercent, "%");
      this.fill.style.width = "".concat(maxPercent - minPercent, "%");
    }
  }, {
    key: "updateDisplayValues",
    value: function updateDisplayValues() {
      var minVal = this.getMinValue();
      var maxVal = this.getMaxValue();
      if (this.valueMinDisplay) {
        this.valueMinDisplay.textContent = minVal;
      }
      if (this.valueMaxDisplay) {
        this.valueMaxDisplay.textContent = maxVal;
      }
    }
  }, {
    key: "validateValue",
    value: function validateValue(value, isMin) {
      // Allow empty string during typing
      if (value === '' || value === null || value === undefined) {
        return isMin ? this.min : this.max;
      }
      var num = parseInt(value);
      if (isNaN(num)) {
        return isMin ? this.min : this.max;
      }

      // Clamp to bounds
      if (num < this.min) num = this.min;
      if (num > this.max) num = this.max;

      // Enforce min gap
      if (isMin) {
        var maxVal = this.getMaxValue();
        if (maxVal - num < this.minGap) {
          num = maxVal - this.minGap;
          if (num < this.min) num = this.min;
        }
      } else {
        var minVal = this.getMinValue();
        if (num - minVal < this.minGap) {
          num = minVal + this.minGap;
          if (num > this.max) num = this.max;
        }
      }
      return num;
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var _this2 = this;
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Clear existing timer if any
      if (this.filterDebounceTimer) {
        clearTimeout(this.filterDebounceTimer);
        this.filterDebounceTimer = null;
      }

      // Apply filter immediately or after debounce delay
      var applyFilterNow = function applyFilterNow() {
        var form = _this2.container.closest('form');
        if (form) {
          // Dispatch change event on form to trigger filter update
          var changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
          });
          form.dispatchEvent(changeEvent);
        }
      };
      if (immediate) {
        applyFilterNow();
      } else {
        // Debounce filter application for slider movements
        this.filterDebounceTimer = setTimeout(applyFilterNow, this.filterDebounceDelay);
      }
    }
  }, {
    key: "handleMinSlider",
    value: function handleMinSlider() {
      if (this.updatingFromInput) return;
      this.updatingFromSlider = true;
      var value = this.getMinValue();
      var maxVal = this.getMaxValue();

      // Enforce min gap
      if (maxVal - value < this.minGap) {
        value = maxVal - this.minGap;
        this.rangeMin.value = value;
      }

      // Update input
      this.inputMin.value = value;

      // Update visual immediately (no debounce for UI updates)
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromSlider = false;

      // Apply filter with debounce (delayed)
      this.applyFilter(false);
    }
  }, {
    key: "handleMaxSlider",
    value: function handleMaxSlider() {
      if (this.updatingFromInput) return;
      this.updatingFromSlider = true;
      var value = this.getMaxValue();
      var minVal = this.getMinValue();

      // Enforce min gap
      if (value - minVal < this.minGap) {
        value = minVal + this.minGap;
        this.rangeMax.value = value;
      }

      // Update input
      this.inputMax.value = value;

      // Update visual immediately (no debounce for UI updates)
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromSlider = false;

      // Apply filter with debounce (delayed)
      this.applyFilter(false);
    }
  }, {
    key: "handleMinInput",
    value: function handleMinInput() {
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;

      // Don't validate or constrain while typing - let user type freely
      var inputValue = this.inputMin.value;

      // Only update slider and display if input is a valid number
      // Don't constrain the input value itself
      if (inputValue !== '' && !isNaN(parseInt(inputValue))) {
        var numValue = parseInt(inputValue);

        // Only update slider if within reasonable bounds (don't constrain input)
        if (numValue >= 0) {
          // Use the input value for slider, but clamp slider to max
          var sliderValue = numValue > this.max ? this.max : numValue;

          // Constrain slider to min gap
          var maxVal = this.getMaxValue();
          if (maxVal - sliderValue < this.minGap) {
            sliderValue = maxVal - this.minGap;
            if (sliderValue < this.min) sliderValue = this.min;
          }

          // Update slider position only (don't change input value)
          this.rangeMin.value = sliderValue;
          this.updateFill();
        }

        // Update display with input value (or max if over)
        if (this.valueMinDisplay) {
          this.valueMinDisplay.textContent = numValue > this.max ? this.max : numValue;
        }
      }
      this.updatingFromInput = false;

      // Apply filter with debounce for input typing
      this.applyFilter(false);
    }
  }, {
    key: "handleMinInputBlur",
    value: function handleMinInputBlur() {
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;
      if (!this.inputMin.value || this.inputMin.value === '') {
        this.inputMin.value = this.min;
        this.rangeMin.value = this.min;
      } else {
        var value = this.validateValue(this.inputMin.value, true);
        this.inputMin.value = value;
        this.rangeMin.value = value;
      }
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromInput = false;
      // Apply filter immediately on blur
      this.applyFilter(true);
    }
  }, {
    key: "handleMaxInput",
    value: function handleMaxInput() {
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;

      // Don't validate or constrain while typing - let user type freely
      var inputValue = this.inputMax.value;

      // Only update slider and display if input is a valid number
      // Don't constrain the input value itself
      if (inputValue !== '' && !isNaN(parseInt(inputValue))) {
        var numValue = parseInt(inputValue);

        // Only update slider if within reasonable bounds (don't constrain input)
        if (numValue >= 0) {
          // Use the input value for slider, but clamp slider to max
          var sliderValue = numValue > this.max ? this.max : numValue;

          // Constrain slider to min gap
          var minVal = this.getMinValue();
          if (sliderValue - minVal < this.minGap) {
            sliderValue = minVal + this.minGap;
            if (sliderValue > this.max) sliderValue = this.max;
          }

          // Update slider position only (don't change input value)
          this.rangeMax.value = sliderValue;
          this.updateFill();
        }

        // Update display with input value (or max if over)
        if (this.valueMaxDisplay) {
          this.valueMaxDisplay.textContent = numValue > this.max ? this.max : numValue;
        }
      }
      this.updatingFromInput = false;

      // Apply filter with debounce for input typing
      this.applyFilter(false);
    }
  }, {
    key: "handleMaxInputBlur",
    value: function handleMaxInputBlur() {
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;
      if (!this.inputMax.value || this.inputMax.value === '') {
        this.inputMax.value = this.max;
        this.rangeMax.value = this.max;
      } else {
        var value = this.validateValue(this.inputMax.value, false);
        this.inputMax.value = value;
        this.rangeMax.value = value;
      }
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromInput = false;
      // Apply filter immediately on blur
      this.applyFilter(true);
    }
  }]);
}(); // Initialize all price sliders on page load and after AJAX updates
function initPriceSliders() {
  var containers = document.querySelectorAll('.price-range-filter');
  containers.forEach(function (container) {
    // Clear existing instance if it exists (for re-initialization after AJAX)
    if (container.priceSliderInstance) {
      container.priceSliderInstance = null;
    }
    // Create new instance
    container.priceSliderInstance = new PriceRangeSlider(container);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPriceSliders);
} else {
  initPriceSliders();
}

// Re-initialize after AJAX updates (for dynamic content)
document.addEventListener('filterUpdated', initPriceSliders);

// Export for use in other scripts
window.initPriceSliders = initPriceSliders;

/***/ }),

/***/ "./src/js/sliders.js":
/*!***************************!*\
  !*** ./src/js/sliders.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debounceReInitSliders: () => (/* binding */ debounceReInitSliders),
/* harmony export */   destroyHomeHeroAsideMobileSlider: () => (/* binding */ destroyHomeHeroAsideMobileSlider),
/* harmony export */   initHomeHeroAsideMobileSlider: () => (/* binding */ initHomeHeroAsideMobileSlider)
/* harmony export */ });
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-slider */ "./node_modules/slick-slider/slick/slick.js");
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_slider__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _find_my_pot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./find-my-pot */ "./src/js/find-my-pot.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");


var mq = {
  xs: 425,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600
};

/***********************
 ***********************
 *** Oppot Slider ***
 ***********************
 ***********************/
var OppotSliderSelector = ".js-oppot-slider";
var OppotSliderAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  grabCursor: true,
  dots: false,
  arrows: false,
  rows: 0,
  speed: 150,
  swipeToSlide: true,
  infinite: false,
  draggable: true,
  swipe: true,
  touchMove: true,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 2.5
    }
  }, {
    breakpoint: mq.xs,
    settings: {
      slidesToShow: 2.5
    }
  }]
};

// Init the slider
function initOppotSlider() {
  // Remove slick if it was previously initialized
  var $slider = $(OppotSliderSelector);
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  // Native scrolling is handled by CSS
}

/***************************
 ***************************
 ***  Drawer Crosssells  ***
 ***************************
 ***************************/
var DrawerCrosssellsSelector = ".js-drawer-crosssells";
var DrawerCrosssellsAttributes = {
  slidesToShow: 1.5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  infinite: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 1.5
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 1.25
    }
  }]
};
// Init the slider
function initDrawerCrosssels() {
  $(DrawerCrosssellsSelector).slick(DrawerCrosssellsAttributes);
}

/***********************
 ***********************
 ***  Home Hero USP  ***
 ***********************
 ***********************/
var HomeHeroUspSelector = ".js-home-hero-usp-slider";
var HomeHeroUspAttributes = {
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 1,
  infinite: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2,
      dots: true,
      infinite: true
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1,
      arrows: false,
      dots: false,
      infinite: true,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 3000
    }
  }]
};
// Init the slider
function initHomeHeroUsp() {
  $(HomeHeroUspSelector).slick(HomeHeroUspAttributes);
}

/****************************
 ****************************
 *** Home Products Slider ***
 ****************************
 ****************************/
var HomeProductsSliderSelector = ".js-home-products-slider";
var MOBILE_BREAKPOINT = '(max-width: 991.98px)';
var HomeProductsSliderAttributes = {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3,
      infinite: false
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-home-products-slider-prev"),
      nextArrow: $(".js-home-products-slider-next")
    }
  }]
};

// Init the slider - slick on desktop, native scroll on mobile
function initHomeProductsSlider() {
  var slider = document.querySelector(HomeProductsSliderSelector);
  if (!slider) return;
  var wrapper = slider.closest('.home-products-slider-wrapper');
  var scrollbarTrack = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('.home-products-scrollbar-track');

  // Check if mobile
  var isMobile = function isMobile() {
    return window.matchMedia(MOBILE_BREAKPOINT).matches;
  };

  // Initialize based on screen size
  function initSlider() {
    if (isMobile()) {
      // Mobile: Remove slick, use native scrolling
      if ($(slider).hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      }
      initMobileScrollbar();
    } else {
      // Desktop: Use slick slider
      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(HomeProductsSliderAttributes);
      }
      if (scrollbarTrack) {
        scrollbarTrack.style.display = 'none';
      }
    }
  }

  // Initialize mobile scrollbar
  function initMobileScrollbar() {
    if (!scrollbarTrack) return;
    scrollbarTrack.style.display = '';

    // Create or get thumb element
    var thumb = scrollbarTrack.querySelector('.home-products-scrollbar-thumb');
    if (!thumb) {
      thumb = document.createElement('div');
      thumb.className = 'home-products-scrollbar-thumb';
      scrollbarTrack.appendChild(thumb);
    }

    // Update thumb position
    var updateThumb = function updateThumb() {
      if (!isMobile()) {
        thumb.style.display = 'none';
        scrollbarTrack.style.display = 'none';
        return;
      }
      var scrollWidth = slider.scrollWidth;
      var clientWidth = slider.clientWidth;
      var scrollLeft = slider.scrollLeft;
      var maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        thumb.style.display = 'none';
        scrollbarTrack.style.display = 'none';
        return;
      }
      thumb.style.display = 'block';
      scrollbarTrack.style.display = 'block';
      var thumbWidth = clientWidth / scrollWidth * 100;
      var thumbLeft = scrollLeft / maxScroll * (100 - thumbWidth);
      thumb.style.width = "".concat(thumbWidth, "%");
      thumb.style.left = "".concat(thumbLeft, "%");
    };

    // Set up event listeners
    slider.addEventListener('scroll', updateThumb, {
      passive: true
    });
    var resizeObserver = new ResizeObserver(updateThumb);
    resizeObserver.observe(slider);

    // Initial update
    updateThumb();
    requestAnimationFrame(function () {
      updateThumb();
      setTimeout(updateThumb, 100);
    });
  }

  // Handle media query changes
  var mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
  mediaQuery.addEventListener('change', initSlider);

  // Initial setup
  initSlider();
}

/************************
 ************************
 *** Home Sale Slider ***
 ************************
 ************************/
var HomeSaleSliderSelector = ".js-home-sale-slider";
var HomeSaleSliderAttributes = {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3,
      infinite: false
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-home-sale-slider-prev"),
      nextArrow: $(".js-home-sale-slider-next")
    }
  }]
};

// Init the slider
function initHomeSaleSlider() {
  $(HomeSaleSliderSelector).slick(HomeSaleSliderAttributes);
}

/****************************
 ****************************
 *** Home Category Slider ***
 ****************************
 ****************************/
var HomeCategorySliderSelector = ".js-home-category-slider";
var HomeCategorySliderAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3,
      infinite: false
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2,
      infinite: false
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.25,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-home-sale-slider-prev"),
      nextArrow: $(".js-home-sale-slider-next")
    }
  }]
};

// Init the slider
function initHomeCategorySlider() {
  $(HomeCategorySliderSelector).slick(HomeCategorySliderAttributes);
}

/************************
 ************************
 *** Home News Slider ***
 ************************
 ************************/
var HomeNewsSliderSelector = ".js-home-news-slider";
var HomeNewsSliderAttributes = {
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.1,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-home-news-slider-prev"),
      nextArrow: $(".js-home-news-slider-next")
    }
  }]
};

// Init the slider
function initHomeNewsSlider() {
  $(HomeNewsSliderSelector).slick(HomeNewsSliderAttributes);
}

/*********************
 *********************
 *** Upsell Slider ***
 *********************
 *********************/
var UpsellSliderSelector = ".js-upsell-slider";
var UpsellSliderAttributes = {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.5,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-upsell-slider-prev"),
      nextArrow: $(".js-upsell-slider-next")
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 2,
      arrows: true,
      prevArrow: $(".js-upsell-slider-prev"),
      nextArrow: $(".js-upsell-slider-next")
    }
  }]
};

// Init the slider
function initUpsellSlider() {
  $(UpsellSliderSelector).slick(UpsellSliderAttributes);
}

/******************************
 ******************************
 *** Layout Products Slider ***
 ******************************
 ******************************/
var LayoutProductsSliderSelector = ".js-layout-products";
var LayoutProductsSliderAttributes = {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.5,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-layout-products-prev"),
      nextArrow: $(".js-layout-products-next")
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 2,
      arrows: true,
      prevArrow: $(".js-layout-products-prev"),
      nextArrow: $(".js-layout-products-next")
    }
  }]
};

// Init the slider
function initLayoutProductsSlider() {
  $(LayoutProductsSliderSelector).slick(LayoutProductsSliderAttributes);
}

/********************************
 ********************************
 *** Product Hero Main Slider ***
 ********************************
 ********************************/
var ProductHeroMainSliderSelector = ".js-product-hero-main-slider";
var ProductHeroMainSliderAttributes = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  rows: 0,
  infinite: false
};
function initProductHeroMainSlider() {
  $(ProductHeroMainSliderSelector).slick(ProductHeroMainSliderAttributes);

  // Sync nav slider with main slider
  var mainSlider = document.querySelector(ProductHeroMainSliderSelector);
  if (mainSlider) {
    $(mainSlider).on('afterChange', function (event, slick, currentSlide) {
      // Update active nav slide
      var navSlides = document.querySelectorAll('.product-hero-main-nav__slide');
      navSlides.forEach(function (slide, index) {
        if (index === currentSlide) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    });
  }
}
function goToSlide(index) {
  $(ProductHeroMainSliderSelector).slick('slickGoTo', index);
}

/****************************
 ****************************
 *** Product Hero Main Nav ***
 ****************************
 ****************************/
var ProductHeroMainNavSelector = ".js-product-hero-main-nav";
var ProductHeroMainNavAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".js-product-hero-main-slider",
  dots: false,
  focusOnSelect: true,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2,
      vertical: true,
      verticalSwiping: true
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      vertical: true,
      verticalSwiping: true,
      arrows: false,
      infinite: false
    }
  }]
};
function initProductHeroMainNav() {
  // Remove Slick Slider, use native horizontal scroll
  var navSlider = document.querySelector(ProductHeroMainNavSelector);
  if (navSlider) {
    // Un-slick if already initialized
    if ($(navSlider).hasClass('slick-initialized')) {
      $(navSlider).slick('unslick');
    }

    // Initialize scrollbar thumb
    initProductNavScrollbarThumb();

    // Handle click on nav slides to sync with main slider
    var slides = navSlider.querySelectorAll('.product-hero-main-nav__slide');

    // Set first slide as active by default
    if (slides.length > 0) {
      slides[0].classList.add('active');
    }
    slides.forEach(function (slide, index) {
      slide.addEventListener('click', function () {
        // Remove active class from all slides
        slides.forEach(function (s) {
          return s.classList.remove('active');
        });
        // Add active class to clicked slide
        slide.classList.add('active');

        // Check if mobile (vertical layout)
        var isMobile = window.matchMedia('(max-width: 991.98px)').matches;

        // Scroll slide into view
        if (isMobile) {
          // Vertical scroll on mobile
          slide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        } else {
          // Horizontal scroll on desktop
          slide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }

        // Sync with main slider if it exists
        var mainSlider = document.querySelector('.js-product-hero-main-slider');
        if (mainSlider && $(mainSlider).hasClass('slick-initialized')) {
          $(mainSlider).slick('slickGoTo', index);
        }
      });
    });
  }
}

// Initialize scrollbar thumb for product nav slider
function initProductNavScrollbarThumb() {
  var navSlider = document.querySelector('.js-product-hero-main-nav');
  var scrollbarTrack = document.querySelector('.product-hero-main-nav-scrollbar-track');
  if (!navSlider || !scrollbarTrack) return;

  // Check if mobile (vertical layout)
  function isMobile() {
    return window.matchMedia('(max-width: 991.98px)').matches;
  }

  // Create thumb element
  var thumb = scrollbarTrack.querySelector('.product-hero-main-nav-scrollbar-thumb');
  if (!thumb) {
    thumb = document.createElement('div');
    thumb.className = 'product-hero-main-nav-scrollbar-thumb';
    scrollbarTrack.appendChild(thumb);
  }

  // Update thumb position and size
  function updateThumb() {
    // Hide thumb on mobile (vertical layout)
    if (isMobile()) {
      thumb.style.display = 'none';
      return;
    }
    var containerWidth = navSlider.offsetWidth;
    var scrollWidth = navSlider.scrollWidth;
    var scrollLeft = navSlider.scrollLeft;
    if (scrollWidth <= containerWidth) {
      thumb.style.display = 'none';
      return;
    }
    thumb.style.display = 'block';
    var thumbWidth = containerWidth / scrollWidth * 100;
    var thumbLeft = scrollLeft / (scrollWidth - containerWidth) * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = thumbLeft + '%';
  }

  // Update on scroll
  navSlider.addEventListener('scroll', updateThumb);

  // Update on resize
  var resizeObserver = new ResizeObserver(updateThumb);
  resizeObserver.observe(navSlider);

  // Listen for window resize to handle mobile/desktop switch
  window.addEventListener('resize', updateThumb);

  // Initial update
  updateThumb();

  // Update after a short delay to ensure content is loaded
  setTimeout(updateThumb, 100);
  setTimeout(updateThumb, 500);
}

/********************************
 ********************************
 *** Product Hero Main Slider ***
 ********************************
 ********************************/
var HomeHeroAsideMobileSelector = ".js-home-hero-aside-mobile";
var HomeHeroAsideMobileAttributes = {
  slidesToShow: 1.5,
  slidesToScroll: 1,
  mobileFirst: true,
  arrows: false,
  dots: false,
  infinite: false
};
function initHomeHeroAsideMobileSlider() {
  $(HomeHeroAsideMobileSelector).slick(HomeHeroAsideMobileAttributes);
}
function destroyHomeHeroAsideMobileSlider() {
  if ($(HomeHeroAsideMobileSelector).hasClass("slick-initialized")) {
    $(HomeHeroAsideMobileSelector).slick("unslick");
  }
}

// Init all sliders
initHomeHeroUsp();
initDrawerCrosssels();
initHomeProductsSlider();
initHomeSaleSlider();
initHomeCategorySlider();
initHomeNewsSlider();
initUpsellSlider();
initLayoutProductsSlider();
initProductHeroMainSlider();
initProductHeroMainNav();

// Re init function
function reInitSliders() {
  // Unset the slick of all .slick-initialized
  $(".slick-initialized").slick("unslick");

  // Re init all sliders
  initHomeHeroUsp();
  initDrawerCrosssels();
  initHomeProductsSlider();
  initHomeSaleSlider();
  initHomeCategorySlider();
  initHomeNewsSlider();
  initUpsellSlider();
  initLayoutProductsSlider();
  initProductHeroMainSlider();
  initProductHeroMainNav();

  // This is the exceptional version:
  initOppotSlider();
}
var screenWidth = $(window).width();

// Debounce function to limit the frequency of reInitSliders calls
var resizeTimeout;
function debounceReInitSliders() {
  // If the width is the same, don't reInit
  if (screenWidth === $(window).width()) {
    return;
  }
  screenWidth = $(window).width();
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    reInitSliders();
  }, 200); // Adjust the delay as needed (in milliseconds)
}

// Add event listeners for resize and orientation change
window.addEventListener("resize", debounceReInitSliders);
window.addEventListener("orientationchange", debounceReInitSliders);
window.addEventListener("variationchange", function (e) {
  return goToSlide(e.detail.index);
});

// Fix the slider with the oppot values
function initOppotConfigurator() {
  // Order divs first
  var $slider = $(".js-oppot-slider");
  var $slides = $(".js-oppot-slider>div");
  var uniqueVariations = [];
  $slides.sort(function (a, b) {
    var orderA = $(a).data("order");
    var orderB = $(b).data("order");

    // First sort by data-order
    if (orderA !== orderB) {
      return orderA - orderB;
    }

    // If data-order is the same, sort by data-suborder
    var subOrderA = $(a).data("suborder");
    var subOrderB = $(b).data("suborder");
    return subOrderA - subOrderB;
  }).each(function (index, slide) {
    var variation = $(slide).find("input").val();
    if (!uniqueVariations.includes(variation)) {
      uniqueVariations.push(variation);
    } else {
      $slides.splice(index, 1);
    }
  });
  // Empty the slider
  $slider.empty();

  // Add the slides back in
  $slides.each(function (index, slide) {
    $slider.append(slide);
  });

  // Now init the configurator
  if (document.getElementById("find_my_pot_configurator")) {
    initOppotSlider();
    new _find_my_pot__WEBPACK_IMPORTED_MODULE_1__.PotFinder();
  }
  initOppotScrollbarThumb();
}
initOppotConfigurator();

// Create custom scrollbar thumb that's always visible
function initOppotScrollbarThumb() {
  var slider = document.querySelector('.js-oppot-slider');
  if (!slider) return;
  var wrapper = slider.closest('.oppot-slider-wrapper');
  if (!wrapper) return;

  // Remove existing thumb if any
  var existingThumb = wrapper.querySelector('.oppot-scrollbar-thumb');
  if (existingThumb) {
    existingThumb.remove();
  }

  // Create thumb element
  var thumb = document.createElement('div');
  thumb.className = 'oppot-scrollbar-thumb';
  wrapper.appendChild(thumb);
  function updateThumb() {
    var scrollWidth = slider.scrollWidth;
    var clientWidth = slider.clientWidth;
    var scrollLeft = slider.scrollLeft;
    var maxScroll = scrollWidth - clientWidth;
    if (maxScroll <= 0) {
      thumb.style.display = 'none';
      return;
    }
    thumb.style.display = 'block';
    var thumbWidth = clientWidth / scrollWidth * 100;
    var thumbLeft = scrollLeft / maxScroll * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = thumbLeft + '%';
  }

  // Update on scroll
  slider.addEventListener('scroll', updateThumb);

  // Update on resize
  var resizeObserver = new ResizeObserver(updateThumb);
  resizeObserver.observe(slider);

  // Initial update
  updateThumb();

  // Update after a short delay to ensure content is loaded
  setTimeout(updateThumb, 100);
  setTimeout(updateThumb, 500);
}

// Export the reInitSliders function


/***/ }),

/***/ "./src/js/toggles.js":
/*!***************************!*\
  !*** ./src/js/toggles.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");

$(document).on("click", ".js-footer-toggle ", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next("nav").children("ul").stop().slideToggle();
});

// Sluit alle panels
function closeAllPanels() {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeAccountPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
  $("html").removeClass("show-nav");
  $(".js-header-toggle").removeClass("is-active");
}
$(".js-header-search input").on("input", function () {
  if ($(this).val().length > 0) {
    closeAllPanels();
  }
});
$(document).on("click", ".js-header-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $("html").toggleClass("show-nav");
});

// Minicart openen/sluiten
$(document).on("click", ".js-cart-toggle", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-minicart-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});

// Taalpanel openen/sluiten
$(document).on("click", ".js-lang-switch", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-lang-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});

// Accountpanel openen/sluiten
$(document).on("click", ".js-account-toggle", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openAccountPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-account-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeAccountPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});

// Filterpanel openen/sluiten
$(document).on("click", ".js-header-collection-mobile-filter", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-filter-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});
$(document).on("click", ".js-collection-filter-toggle", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.filterToggle)($(this));
});
$(document).on("click", ".js-show-more", function (e) {
  var readMore = $(this);
  var container = readMore.parent().find(".js-content-container");
  var newHeight = container.find(".colums-2").height();
  if (container.hasClass("is-show")) {
    $(".js-content-container").animate({
      height: 100
    }, 500);
    container.removeClass("is-show");
    $(this).next(span).html("Toon minder");
  } else {
    $(".js-content-container").animate({
      height: newHeight
    }, 500);
    container.addClass("is-show");
    $(this).next(span).html("Toon minder");
  }
});
$(document).on("click", ".js-faq-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).next().stop().slideToggle(300);
});
$(document).on("click", ".js-mega-menu-toggle i", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).parent().find(".mega-menu").toggleClass("is-active");
});
$(document).on("click", ".js-megamenu-return", function (e) {
  e.preventDefault();
  $(this).closest(".mega-menu").removeClass("is-active");
  $(this).closest("li").find(".js-mega-menu-toggle i").removeClass("is-active");
});
$(document).on("click", ".js-child-toggle i", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next("ul").slideToggle();
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["app","/vendor"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/scss/app.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);